/** DOM helpers for evaluation print (OTK + CRM). */

import { uiT } from './uiTranslate';

export function stripNoPrintElements(el) {
  if (!el?.querySelectorAll) return;
  el.querySelectorAll('.no-print').forEach((node) => node.remove());
}

export function expandScrollablesInElement(el) {
  if (!el || !el.querySelectorAll) return;
  const sel = [
    '.p-datatable-scrollable-body',
    '.p-datatable-scrollable-wrapper',
    '.p-datatable-scrollable',
    '.p-treetable-scrollable-body',
    '.p-treetable-scrollable-wrapper',
    '.p-treetable-scrollable',
  ].join(',');
  el.querySelectorAll(sel).forEach((node) => {
    node.style.setProperty('height', 'auto', 'important');
    node.style.setProperty('max-height', 'none', 'important');
    node.style.setProperty('min-height', '0', 'important');
    node.style.setProperty('overflow', 'visible', 'important');
    node.style.setProperty('overflow-y', 'visible', 'important');
    node.style.setProperty('overflow-x', 'visible', 'important');
  });
}

export function processFilterRowsForPrint(el) {
  if (!el || !el.querySelectorAll) return;
  const filterRows = el.querySelectorAll('.p-datatable thead tr.p-datatable-filter-row, .p-datatable thead tr:has(.p-column-filter), .p-treetable thead tr.p-datatable-filter-row, .p-treetable thead tr:has(.p-column-filter)');
  filterRows.forEach((row) => {
    row.style.display = 'none';
  });
  el.querySelectorAll('.p-datatable thead, .p-treetable thead').forEach((thead) => {
    const rows = thead.querySelectorAll('tr');
    for (let i = 1; i < rows.length; i++) rows[i].style.display = 'none';
  });
}

export function processInputsToTextForPrint(el) {
  if (!el || !el.querySelectorAll) return;
  el.querySelectorAll('.p-calendar').forEach((cal) => {
    const input = cal.querySelector('input');
    const val = input?.value?.trim() || '';
    const span = document.createElement('span');
    span.className = 'print-text-value';
    span.textContent = val || '—';
    span.style.fontSize = '11px';
    cal.parentNode?.replaceChild(span, cal);
  });
  el.querySelectorAll('.p-dropdown').forEach((dd) => {
    if (dd.closest('.p-datatable thead, .p-treetable thead')) return;
    const label = dd.querySelector('.p-dropdown-label');
    const txt = (label?.innerText || '').trim() || '—';
    const span = document.createElement('span');
    span.className = 'print-text-value';
    span.textContent = txt;
    span.style.fontSize = '11px';
    dd.parentNode?.replaceChild(span, dd);
  });
  el.querySelectorAll('.p-multiselect').forEach((ms) => {
    if (ms.closest('.p-datatable thead, .p-treetable thead')) return;
    const labelEl = ms.querySelector('.p-multiselect-label');
    const txt = (labelEl?.innerText || '').trim() || '—';
    const span = document.createElement('span');
    span.className = 'print-text-value';
    span.textContent = txt;
    span.style.fontSize = '11px';
    ms.parentNode?.replaceChild(span, ms);
  });
}

export function processRemoveCardWrapperForPrint(el) {
  if (!el || !el.querySelectorAll) return;
  el.querySelectorAll('.print-full > .p-card').forEach((card) => {
    const parent = card.parentNode;
    const header = card.querySelector('.p-card-header');
    const content = card.querySelector('.p-card-content, .p-card-body');
    if (header) parent.insertBefore(header, card);
    if (content) {
      while (content.firstChild) {
        parent.insertBefore(content.firstChild, card);
      }
    }
    card.remove();
  });
}

export function processRemovePeriodBlockForPrint(el) {
  if (!el || !el.querySelectorAll) return;
  el.querySelectorAll('.flex.items-center.gap-3, .flex.items-center.gap-2').forEach((block) => {
    const text = block.textContent || '';
    if (text.includes('Obdobie:') && block.querySelector('.p-calendar')) {
      block.remove();
    }
  });
}

export function processRemoveEmptyChartSectionsForPrint(el) {
  if (!el || !el.querySelectorAll) return;
  el.querySelectorAll('.print-charts-section').forEach((section) => {
    const hasChart =
      section.querySelector('.print-chart-item') != null
      || section.querySelector('.print-chart-bare') != null
      || section.querySelector('canvas') != null;
    if (!hasChart) section.remove();
  });
}

export function processChartCardsForPrint(el) {
  if (!el || !el.querySelectorAll) return;
  el.querySelectorAll('.print-chart-item').forEach((card) => {
    const titleEl = card.querySelector('.p-card-title, [class*="card-title"]');
    const title = titleEl?.innerText || '';
    const trendInfoEl = card.querySelector('.print-trend-chart-info');
    const chartEl = card.querySelector('canvas, img');
    if (!chartEl) return;
    const wrap = document.createElement('div');
    wrap.className = 'print-chart-bare';
    const titleDiv = document.createElement('div');
    titleDiv.className = 'print-chart-bare-title';
    titleDiv.textContent = title;
    wrap.appendChild(titleDiv);
    if (trendInfoEl) {
      const infoClone = trendInfoEl.cloneNode(true);
      infoClone.style.display = 'block';
      wrap.appendChild(infoClone);
    }
    wrap.appendChild(chartEl.cloneNode(true));
    card.replaceWith(wrap);
  });
}

export function convertCanvasesToImages(sourceEl, cloneEl) {
  if (!sourceEl || !cloneEl) return;
  const srcCanvases = sourceEl.querySelectorAll ? sourceEl.querySelectorAll('canvas') : [];
  const cloneCanvases = cloneEl.querySelectorAll ? cloneEl.querySelectorAll('canvas') : [];
  for (let i = 0; i < Math.min(srcCanvases.length, cloneCanvases.length); i++) {
    const src = srcCanvases[i];
    const clone = cloneCanvases[i];
    try {
      const dataUrl = src.toDataURL ? src.toDataURL('image/png') : null;
      if (dataUrl && clone?.parentNode) {
        const img = document.createElement('img');
        img.src = dataUrl;
        img.style.width = '100%';
        img.style.maxWidth = clone.width ? `${clone.width}px` : '100%';
        img.style.height = 'auto';
        img.style.display = 'block';
        clone.parentNode.replaceChild(img, clone);
      }
    } catch (_) {
      // ignore canvas conversion failures
    }
  }
}

export function mergeScrollableHeadersForPrint(container) {
  if (!container || !container.querySelectorAll) return;
  const prependHeaderRows = (headerThead, bodyThead) => {
    if (!headerThead || !bodyThead) return;
    const rows = Array.from(headerThead.querySelectorAll('tr'));
    for (let i = rows.length - 1; i >= 0; i--) {
      const clone = rows[i].cloneNode(true);
      bodyThead.insertBefore(clone, bodyThead.firstChild);
    }
  };
  container.querySelectorAll('.p-datatable-scrollable').forEach((scrollable) => {
    const headerTable = scrollable.querySelector('.p-datatable-scrollable-header table');
    const bodyTable = scrollable.querySelector('.p-datatable-scrollable-body table');
    if (!headerTable || !bodyTable) return;
    const headerThead = headerTable.querySelector('thead');
    if (!headerThead) return;
    const bodyThead = bodyTable.querySelector('thead');
    if (bodyThead) {
      prependHeaderRows(headerThead, bodyThead);
    } else {
      const clonedThead = headerThead.cloneNode(true);
      bodyTable.insertBefore(clonedThead, bodyTable.firstChild);
    }
    const headerWrapper = scrollable.querySelector('.p-datatable-scrollable-header');
    if (headerWrapper) headerWrapper.style.display = 'none';
  });
}

export function moveScrollableFootersAfterBodyForPrint(container) {
  if (!container?.querySelectorAll) return;

  container.querySelectorAll('.p-datatable-scrollable-footer, .p-treetable-scrollable-footer').forEach((footer) => {
    const scrollable = footer.closest('.p-datatable-scrollable, .p-treetable-scrollable, .p-datatable-scrollable-wrapper, .p-treetable-scrollable-wrapper');
    const body = scrollable?.querySelector('.p-datatable-scrollable-body, .p-treetable-scrollable-body');
    if (!scrollable || !body || !footer.parentNode) return;

    if (body.nextSibling !== footer) {
      body.parentNode?.insertBefore(footer, body.nextSibling);
    }
  });
}

export function extractTitleAndSubtitle(sourceEl) {
  if (!sourceEl) return { title: '', subtitle: '', subtitleValues: null };

  let title = '';
  let subtitle = '';
  let subtitleValues = null;

  const titleEl = sourceEl.querySelector('.p-card-title')
    || sourceEl.querySelector('.p-card-header .p-card-title')
    || sourceEl.querySelector('.p-card-header [class*="title"]');
  if (titleEl) {
    title = titleEl.textContent.trim();
    title = title.replace(/Porovnať s obdobím/gi, '').trim();
    title = title.replace(/\s*Tabuľka\s*Graf\s*|\s*Graf\s*Tabuľka\s*/gi, ' ').trim();
    title = title.replace(/TabuľkaGraf|GrafTabuľka/gi, '').trim();
    title = title.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
  } else {
    const header = sourceEl.querySelector('.p-card-header');
    if (header) {
      const lines = header.textContent.trim().split('\n').map((s) => s.trim()).filter(Boolean);
      if (lines.length > 0) {
        title = lines[0].replace(/Porovnať s obdobím/gi, '').trim();
        title = title.replace(/\s*Tabuľka\s*Graf\s*|\s*Graf\s*Tabuľka\s*/gi, ' ').trim();
        title = title.replace(/TabuľkaGraf|GrafTabuľka/gi, '').trim();
        title = title.replace(/\s+/g, ' ').trim();
      }
    }
  }

  const calendarInputs = sourceEl.querySelectorAll('.p-calendar input');
  if (calendarInputs.length > 0) {
    const values = [];
    calendarInputs.forEach((input) => {
      if (input.value?.trim()) values.push(input.value.trim());
    });
    if (values.length === 2) {
      subtitleValues = values;
      subtitle = `${values[0]} / ${values[1]}`;
    } else if (values.length === 1) {
      subtitle = values[0];
    }
  }

  if (!subtitle && !subtitleValues) {
    const allText = sourceEl.innerText || '';
    const obdobieMatch = allText.match(/Obdobie:\s*([^\n]+)/i);
    if (obdobieMatch?.[1]) {
      subtitle = obdobieMatch[1].trim();
    } else {
      const datePatterns = [
        /\d{2}\/\d{2}/,
        /\d{2}\/\d{2}\s*-\s*\d{2}\/\d{2}/,
        /\d{2}\.\d{4}/,
        /\d{4}/,
      ];
      for (const pattern of datePatterns) {
        const match = allText.match(pattern);
        if (match) {
          subtitle = match[0];
          break;
        }
      }
    }
  }

  return { title, subtitle, subtitleValues };
}

export function evaluationPrintContentHasCharts({ printSelection, allSectionKeys, getRefForKey, allContainerRef }) {
  if (!printSelection?.length) return false;
  if (printSelection.includes('all')) {
    const src = allContainerRef?.current;
    return src?.querySelector?.('canvas, .print-chart-item') != null;
  }
  return printSelection.some((key) => {
    const node = getRefForKey(key);
    return node?.querySelector?.('canvas, .print-chart-item') != null;
  });
}

/**
 * Builds print DOM into printContainerRef (OTK-compatible pipeline).
 */
export function buildEvaluationPrintContentAsync({
  printContainerRef,
  printSelection,
  allSectionKeys,
  getRefForKey,
  logoSrc,
  hasCharts = false,
  onPrepareCharts,
}) {
  return new Promise((resolve) => {
    if (!printContainerRef?.current || !printSelection?.length) {
      setTimeout(() => resolve(false), 100);
      return;
    }

    (async () => {
      await onPrepareCharts?.();
      const waitBeforeClone = hasCharts ? 2200 : 350;
      await new Promise((r) => setTimeout(r, waitBeforeClone));
      if (!printContainerRef.current) {
        resolve(false);
        return;
      }
      printContainerRef.current.innerHTML = '';

      const keysToPrint = printSelection.includes('all')
        ? allSectionKeys
        : printSelection;

      const sections = [];
      const logoPromises = [];

      keysToPrint.forEach((key, idx) => {
        const sourceEl = getRefForKey(key);
        if (!sourceEl?.cloneNode) return;

        const { title, subtitle, subtitleValues } = extractTitleAndSubtitle(sourceEl);
        const clone = sourceEl.cloneNode(true);
        stripNoPrintElements(clone);
        convertCanvasesToImages(sourceEl, clone);

        clone.querySelectorAll('.p-card-title, .p-card-header .p-card-title, .p-card-subtitle, .p-card-content > .text-sm.p-card-subtitle').forEach((el) => {
          el.remove();
        });

        clone.querySelectorAll('.flex.items-center.gap-2').forEach((container) => {
          const hasInputSwitch = container.querySelector('.p-inputswitch');
          const text = container.textContent || '';
          if (hasInputSwitch && (text.includes('Tabuľka') || text.includes('Graf'))) {
            container.remove();
          }
        });

        expandScrollablesInElement(clone);
        mergeScrollableHeadersForPrint(clone);
        moveScrollableFootersAfterBodyForPrint(clone);
        processFilterRowsForPrint(clone);
        processInputsToTextForPrint(clone);
        processChartCardsForPrint(clone);
        processRemoveEmptyChartSectionsForPrint(clone);
        processRemoveCardWrapperForPrint(clone);
        processRemovePeriodBlockForPrint(clone);

        const sectionTable = document.createElement('table');
        sectionTable.className = 'print-section';
        if (idx > 0) sectionTable.style.pageBreakBefore = 'always';

        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        const headerCell = document.createElement('th');
        headerCell.colSpan = 1;
        headerCell.style.width = '100%';
        headerCell.style.padding = '0';
        headerCell.style.border = 'none';

        const headerDiv = document.createElement('div');
        headerDiv.className = 'print-section-header';
        const headerLeft = document.createElement('div');
        headerLeft.className = 'print-section-header-left';

        if (title) {
          const titleDiv = document.createElement('div');
          titleDiv.className = 'print-section-title';
          titleDiv.textContent = title;
          headerLeft.appendChild(titleDiv);
        }

        if (subtitle || subtitleValues) {
          if (subtitleValues?.length === 2) {
            const subtitleContainer = document.createElement('div');
            subtitleContainer.className = 'print-section-subtitle';
            const leftSubtitle = document.createElement('div');
            leftSubtitle.textContent = uiT('OTKEvaluation.PeriodLeft', { value: subtitleValues[0] });
            subtitleContainer.appendChild(leftSubtitle);
            const rightSubtitle = document.createElement('div');
            rightSubtitle.textContent = uiT('OTKEvaluation.PeriodRight', { value: subtitleValues[1] });
            subtitleContainer.appendChild(rightSubtitle);
            headerLeft.appendChild(subtitleContainer);
          } else if (subtitle) {
            let rawSubtitle = subtitle.trim().replace(/^Obdobie:\s*/i, '').trim();
            if (rawSubtitle) {
              const subtitleDiv = document.createElement('div');
              subtitleDiv.className = 'print-section-subtitle';
              subtitleDiv.textContent = `Obdobie: ${rawSubtitle}`;
              headerLeft.appendChild(subtitleDiv);
            }
          }
        }

        headerDiv.appendChild(headerLeft);

        if (logoSrc) {
          const logoImg = document.createElement('img');
          logoImg.className = 'print-section-logo';
          logoImg.src = logoSrc;
          logoImg.alt = '';
          logoImg.setAttribute('style', 'max-height: 22mm; max-width: 45mm; object-fit: contain; display: block;');
          headerDiv.appendChild(logoImg);
          logoPromises.push(new Promise((res) => {
            if (logoImg.complete) res();
            else {
              logoImg.onload = res;
              logoImg.onerror = res;
            }
          }));
        }

        headerCell.appendChild(headerDiv);
        headerRow.appendChild(headerCell);
        thead.appendChild(headerRow);
        sectionTable.appendChild(thead);

        const tbody = document.createElement('tbody');
        const bodyRow = document.createElement('tr');
        const bodyCell = document.createElement('td');
        bodyCell.className = 'print-section-body';
        bodyCell.style.padding = '0';
        bodyCell.style.border = 'none';
        bodyCell.appendChild(clone);
        bodyRow.appendChild(bodyCell);
        tbody.appendChild(bodyRow);
        sectionTable.appendChild(tbody);

        sections.push(sectionTable);
      });

      sections.forEach((section) => {
        printContainerRef.current.appendChild(section);
      });

      if (sections.length === 0) {
        resolve(false);
        return;
      }

      await Promise.all(logoPromises.length > 0 ? logoPromises : [Promise.resolve()]);
      window.dispatchEvent(new Event('resize'));
      await new Promise((r) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(r, 400);
          });
        });
      });
      resolve(true);
    })().catch(() => resolve(false));
  });
}

export const CRM_EVALUATION_PRINT_KEYS = ['claimedOrders', 'claimedPieces', 'repairCost', 'trendPeriod'];
